import { render, staticRenderFns } from "./buddyAIStatistics.vue?vue&type=template&id=7ee65304&scoped=true&"
import script from "./buddyAIStatistics.vue?vue&type=script&lang=ts&"
export * from "./buddyAIStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./buddyAIStatistics.vue?vue&type=style&index=0&id=7ee65304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee65304",
  null
  
)

export default component.exports